import { createReducer } from 'redux-act';
import { TLegacyErrors } from '@alycecom/services';

import { declineGiftRequest, declineGiftSuccess, declineGiftFail, resetErrors } from './decline.actions';

export interface IDeclineState {
  isLoading: boolean;
  isDeclined: boolean;
  errors: TLegacyErrors;
}

export const initialState: IDeclineState = {
  isLoading: false,
  isDeclined: false,
  errors: {},
};

const reducer = createReducer<IDeclineState>({}, initialState);

reducer
  .on(declineGiftRequest, state => ({
    ...state,
    isLoading: true,
  }))
  .on(declineGiftSuccess, (state, payload) => ({
    ...state,
    isDeclined: true,
    countries: payload,
  }))
  .on(declineGiftFail, (state, payload) => ({
    ...state,
    isLoading: false,
    errors: payload,
  }));

reducer.on(resetErrors, state => ({
  ...state,
  errors: {},
}));

export default reducer;
